<template>
  <CCard>
    <CCardHeader>
      <strong>Create Tournament</strong>
    </CCardHeader>
    <CCardBody>
      <form @submit="onSubmit" enctype="multipart/form-data">
        <form-wizard color="#5C13BA" subtitle="" title="Create Tournament">
          <tab-content icon="ti-settings" title="TOURNAMENT INFO">
            <CRow>
              <CCol sm="12">
                <CInput label="Name" placeholder="Enter tournament title" v-model="name" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CLabel htmlFor="type"> Tournament Type</CLabel>
                <CSelect
                    id="type"
                    v-model="type"
                    :options="options"
                    placeholder="Select tournament type"
                    size="sm"
                    custom
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CInput label="Description" placeholder="Enter tournament description" v-model="description" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CSelect label="Partner (optional)" :options="partners" :value.sync="partner_id" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CInputFile
                    label="Banner Thumbnail"
                    vertical
                    ref="file"
                    type="file"
                    @change="onUploadImage"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CInput label="Pass Code (optional)" placeholder="Enter a pass code for tournament entry" v-model="passcode" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CSelect label="Registration Currency" :options="currency_options" :value.sync="currency" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" v-if="currency==='money' || currency==='optional'">
                <CInput label="Registration Fee" type="number" placeholder="Registration Fee (BDT)" v-model="fee" />
              </CCol>
              <CCol sm="12" v-if="currency==='coin' || currency==='optional'">
                <CInput label="Coin Fee" type="number" placeholder="Registration Fee (Coins)" v-model="coin_fee" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CInput label="No. of Prizes" type="number" placeholder="Enter No. of Prizes" v-model="prize_count" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CInput label="No. of Chances" type="number" placeholder="Enter No. of times an user can play this tournament" v-model="chances" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CSelect label="Payment Frequency" :options="payment_frequency" :value.sync="payment_once" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CInput label="Prize" placeholder="Enter First prize" v-model="prize" />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12">
                <CTextarea label="Terms and Conditions" placeholder="Enter Terms & Condition" v-model="tc" rows="10" />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12">
                <label>Tournament Duration</label>
                <VueCtkDateTimePicker label="Start Time" color="#FF2E75" v-model="start_time" />
              </CCol>
            </CRow><CRow>
            <CCol sm="12">
              <VueCtkDateTimePicker label="End Time"  color="#FF2E75" v-model="end_time" />
            </CCol>
          </CRow>
            <CRow>
              <CCol sm="12">
                <input class="m-3" type="checkbox" v-model="status" />Publish
              </CCol>
            </CRow>
          </tab-content>

          <tab-content icon="ti-settings" title="Prize Pool">
            <CRow v-for="(prize, index) in prize_pool" :key="index">
              <CCol sm="4">
                <CInput label="Rank Start" type="number" placeholder="Start from" v-model="prize.rank_start" />
              </CCol>
              <CCol sm="4">
                <CInput label="Rank End" type="number" placeholder="To End" v-model="prize.rank_end" />
              </CCol>
              <CCol sm="3">
                <CInput label="Prize" type="string" placeholder="Prize" v-model="prize.prize" />
              </CCol>
              <CCol sm="1">
                <button class="btn-danger" @click.prevent="remove_prize(index)"><svg xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-trash icon-small" width="24" height="24" viewBox="0 0 24 24"
                    stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path
                      d="M4 7h16M9 7V5h6v2M10 12v4M14 12v4M5 7h14a1 1 0 0 1 1 1v11a1 1 0 0 1 -1 1H5a1 1 0 0 1 -1 -1V8a1 1 0 0 1 1 -1z" />
                  </svg>

                </button>
              </CCol>
            </CRow>

            <CRow style="justify-content: center;">
              <button class="btn btn-lg btn-danger" @click.prevent="add_prize">Add Prize Pool</button>
            </CRow>

          </tab-content>

          <tab-content icon="ti-settings" title="QUESTION SETTINGS">
            <CRow>
              <CCol sm="12">
                <CInput label="Question Set" type="number" placeholder="Enter No. of Questions per set (You have to import total 5 times of this number of question, e.g 100 total questions for choosing 20 question a set" v-model="question_count" />
              </CCol>
              <CCol sm="12">
                <CInput label="Quiz Duration" type="number" placeholder="Entire total duration of each tournament quiz" v-model="duration" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <div class="form-control m-3">
                  <input class="mx-3" type="radio" value="existing" v-model="import_choice" />Import randomly from existing questions&nbsp&nbsp
                  <input  class="mx-3" type="radio" value="new" v-model="import_choice" />Import new from .xlsx file
                  <input  class="mx-3" type="radio" value="random" v-model="import_choice" />Random 200 question
                </div>
              </CCol>
            </CRow>
            <CRow v-if="import_choice==='existing'">
              <CCol sm="12">
                <multiselect
                    v-model="selected_topics"
                    :options="topics"
                    :multiple=true
                    placeholder="Select a topic or All"
                    label="name"
                    track-by="id"
                >
                </multiselect>
              </CCol>
            </CRow>
            <CRow v-else-if="import_choice==='new'">
              <CCol sm="12">
                <CInputFile
                    label=".xls file"
                    vertical
                    ref="file"
                    type="file"
                    @change="onUploadFile"
                />
              </CCol>
              <CCol sm="12">
                <CButton size="sm" variant="outline" color="success" class="mb-3"><a :href="root_url+'/quizgiri_demo_questions.xlsx'" class="text-success">Click here to Download Sample Data (.xlsx)</a></CButton>
              </CCol>
            </CRow>
          </tab-content>
          <button class="btn btn-lg btn-success" slot="finish" type="submit">Create Tournament</button>
        </form-wizard>
      </form>
    </CCardBody>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const ROOT_URL = process.env.VUE_APP_ROOT_URL;
export default {
  name: "TournamentCreate",
  data() {
    return {
      topics: [{ value: 'all', label: 'Any Topic'}],
      partners: [{ value: null, label: 'Select a Partner'}],
      name: "",
      description: "",
      partner_id: "",
      start_time: "",
      end_time:"",
      tc:      `• টুর্নামেন্টে অংশগ্রহণ করার জন্য অবশ্যই সাবস্ক্রিপশন করতে হবে।      
•  আপনি সাবস্ক্রিপশন করেছেন, কিন্তু আপনার পেমেন্ট সফল হয়নি, সেক্ষেত্রে আপনি টুর্নামেন্ট খেলতে পারবেন না।
•  টূর্নামেন্টে যতবার খেলার চান্স থাকবে ততবার ই খেলতে পারবেন।
•  টুর্নামেন্ট সম্পূর্ণ শেষ না করে বের হয়ে গেলে, পুনরায় খেলার চান্স পাওয়া যাবে না।
•  সবচেয়ে কম সময়ে সর্বাধিক পয়েন্ট অর্জনের ক্রম অনুসারে বিজয়ীদের তালিকা নির্ধারণ করা হবে।
•  টুর্নামেন্ট শেষে বিজয়ী ঘোষণা করার ৪ সপ্তাহের মধ্যে যোগাযোগ করে পুরস্কার প্রদান করা হবে।
•  আপনার বিকাশ নম্বর এবং রেজিস্টার্ডকৃত নম্বর একই হতে হবে। 
•  একটি নম্বর থেকে খেললে একাধিক পুরস্কার দেয়া হবে না।
•  পুরষ্কার গ্রহণের জন্যে বিজয়ীদের NID এর কপি প্রদান করে পুরষ্কার গ্রহণ করতে হবে। 
•  ২০ জনের কম প্রতিযোগী অংশগ্রহণ করলে পুরস্কার প্রদান করা হবে না`,
      status: false,
      fee:"0",
      image: "",
      question_count:20,
      duration: "",
      prize_count:"",
      prize:"",
      chances: "",
      selected_topics: "",
      import_choice: "existing",
      import_file:"",
      root_url: ROOT_URL,
      passcode: "",
      currency: "optional",
      coin_fee: "0",
      options: [
        { label: 'General', value: '' },
        { label: 'Mega', value: 'mega' }
      ],
      type:"",
      payment_once: true,
      currency_options: [{value:'money',label:'money'},{value:'coin',label:'coin'},{value:'optional',label:'optional'}],
      payment_frequency: [{value:1,label:'Once'},{value:0, label:'For Every Game'}],
      prize_pool:[{rank_start:1,rank_end:1,prize:0},{rank_start:2,rank_end:2,prize:0},{rank_start:3,rank_end:3,prize:0}]


    };
  },
  created() {
    this.getTopics();
    this.getPartners();
  },
  methods: {

    add_prize() {
      this.prize_pool.push({ rank_start: 0, rank_end: 0, prize: 0 })
    },
    remove_prize(index) {
      if (this.prize_pool.length > 3) {
        this.prize_pool.splice(index, 1)
      } else {
        this.$swal("Error", "Minimum Prize Pool must have 3 prizes", "error");
      }
    },

    getTopics() {
      this.$axios
          .get(`${ADMIN_URL}/topics/`)
          .then((response) => {
            console.log(response.data);
            response.data.topic_list.forEach((e) => {
              this.topics.push({
                id: e.id,
                name: e.name,
              });
            });
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    getPartners() {
      this.$axios
          .get(`${ADMIN_URL}/partners`)
          .then((response) => {
            console.log(response.data);
            response.data.forEach((e) => {
              this.partners.push({
                value: e.id,
                label: e.name,
              });
            });
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    onUploadImage(e) {
      this.image = e[0];
    },
    onUploadFile(e,f) {
      this.import_file = e[0];
    },
    onSubmit(e) {
      e.preventDefault();
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("type", this.type);
      formData.append("description", this.description);
      formData.append("image", this.image);
      formData.append("fee", this.fee);
      formData.append("question_count", this.question_count);
      formData.append("prize_count", this.prize_count);
      formData.append("prize", this.prize);
      formData.append("duration", this.duration);
      formData.append("tc", this.tc);
      formData.append("chances", this.chances);
      formData.append("start_time", this.start_time);
      formData.append("end_time", this.end_time);
      formData.append("status", this.status);
      formData.append("currency", this.currency);
      formData.append("payment_once", this.payment_once);
      formData.append("import_choice", this.import_choice);
      formData.append("prize_pools",JSON.stringify(this.prize_pool))

      if(this.import_choice==='existing')
      {
        formData.append("topics", JSON.stringify(this.selected_topics.map(x=> x.id)));
      }
      else
      {
        formData.append("import_file", this.import_file);
      }

      if(this.passcode.length)
      {
        formData.append("passcode", this.passcode);
      }
      if(this.coin_fee.length)
      {
        formData.append("coin_fee", this.coin_fee);
      }



      this.$axios
          .post(`${ADMIN_URL}/tournaments/store`,formData,config)
          .then((response) => {
            console.log("Success", response);
            console.log(response.data);
            if(response.data.success)
            {
              this.$swal("Success", response.data.message, "success");
              window.location.href = "/tournaments";
            }
            else
            {
              this.$swal("Error",response.data.message, "error");
            }

          })
          .catch((error) => {
            console.log("Error  ... ", error);
            this.$swal("Error", error.response.message, "error");
          });
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

.icon-small {
  width: 16px;  
  height: 16px;  
}
</style>
